module.exports = __webpack_public_path__ + "img/icon_cancel.93712add.svg";